import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { requerido, numero } from './Validaciones';

import { consultaUsuario } from './ConsultaUser';
const ELECTIVA = "ELECTIVA";
export const ConsultaMaterias = (idSemestre, respuesta) => {
    let Content = {
        id: idSemestre,
        semestre: 1
    }

    Post(`${Url}consultMaterias`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            let complemento = "";
            if (data[i].tipomat_name === "ELECTIVA") complemento = ` - [${ELECTIVA}]`

            let search = (data[i].materia_name).indexOf(ELECTIVA);
            if (search === -1) contenido.push({
                value: data[i].id,
                label: `${data[i].materia_name}${complemento}`,
                codigo: data[i].codigo,
            })
            
        }

        respuesta(contenido)
    });
}

export const ConsultaProfesores = (respuesta) => {
    Post(`${Url}consultProfesores`, "", (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push({
                value: data[i].id,
                label: `${data[i].nombre_1} ${data[i].apellido_1}`,
            })
        }

        respuesta(contenido)
    });
}

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorSemestre.value, "", "", "", "Debes seleccionar primero un Semestre de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorMateria.value, "", "", "", "Debes seleccionar una Materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorProfe.value, "", "", "", "Debes seleccionar el Profesor", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.codigo.text, "", "", "", "El Código de la Sección Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Sección Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.cupos.text, "", "", "", "Debes seleccionar la Cantidad de Cupos", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.cupos.text, "", "", "El campo Cupos debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        /* Consultar si la materia existe */
        let Content = { id: campos.codigo.text }
        Post(`${Url}searchSeccion`, Content, (seccExiste) => {
            let data = parseInt(seccExiste);
            if (data > 0){
                errores = 1
                nameErr.push("Ya existe una sección con el mismo nombre")

                respuesta([states, mensaje, errores, nameErr])
            }else{
                consultaUsuario ((usu) => {
            
                    Post(`${Url}addSeccion`, [campos, usu], (resp) => {
                        
                        mensaje = [{
                            status: "info",
                            mensaje: "Se ha guardado correctamente la sección"
                        }];
        
                        
                        respuesta([states, mensaje, errores, nameErr])
                    });
                })
            }
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const ConsultaSecciones = (id, respuesta) => {
    let Content = { id: id }
    Post(`${Url}consultSecciones`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];
        
        for (let i in data) {
            contenido.push({
                id: data[i].id,
                codigo: data[i].codigo,
                materia: data[i].materia_name,
                seccion: data[i].nombre,
            })
        }

        respuesta(contenido)
    });
}

export const verSeccion= (id, respuesta) => {
    let contenido = { id: id, idEst: "" }
    Post(`${Url}verSeccion`, contenido, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];

        /* console.log(data1) */

        let state = {
            cantErrores: "",
            codigo:  { text: data.codigo, status: "" },
            nombre:  { text: data.nombre, status: "" },
            valorMateria: { value: data.materia_id, label: data.materia_name },
            valorProfe: { value: data.profe_id, label: `${data.nombre_1} ${data.apellido_1}` },
            aula:  { text: data.aula, status: "" },
            cupos:  { text: data.cupos, status: "" },
            hora1: data.hora_in,
            hora2: data.hora_out,
            preloaderSecc:{ icon: "", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
            openDelSec: false,
        }

        respuesta (state)
    });
}

export const Editar = (idSecc, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorSemestre.value, "", "", "", "Debes seleccionar primero un Semestre de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorMateria.value, "", "", "", "Debes seleccionar una Materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorProfe.value, "", "", "", "Debes seleccionar el Profesor", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.codigo.text, "", "", "", "El Código de la Sección Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Sección Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.cupos.text, "", "", "", "Debes seleccionar la Cantidad de Cupos", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.cupos.text, "", "", "El campo Cupos debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        /* Consultar si la materia existe */
        let Content = { id: campos.codigo.text, seccion: idSecc}
        Post(`${Url}searchSeccionEdit`, Content, (seccExiste) => {
            let data = parseInt(seccExiste);
            if (data > 0){
                errores = 1
                nameErr.push("Ya existe una sección con el mismo nombre")

                respuesta([states, mensaje, errores, nameErr])
            }else{
                consultaUsuario ((usu) => {
            
                    Post(`${Url}editSeccion`, [campos, usu, idSecc], () => {
                        
                        mensaje = [{
                            status: "info",
                            mensaje: "Se ha modificado correctamente la sección"
                        }];
        
                        
                        respuesta([states, mensaje, errores, nameErr])
                    });
                })
            }
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const Delete = (id, respuesta) => (e) => {
    consultaUsuario ((usu) => {
        let contenido = { id: id }
        Post(`${Url}delSeccion`, [contenido, usu], (resp) => {
            respuesta (resp)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/RegistroFunction.jsx